import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import MasterStaffSiteDetailsComponent from "../components/master-staff/MasterStaffSiteDetailsComponent";

const MasterStaffSiteDetailsPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Site Details"
        routes={[
          { title: "Home", path: "/" },
        ]}
      />
      <MasterStaffSiteDetailsComponent />
    </>
  );
};

export default MasterStaffSiteDetailsPage;
